import React from "react";

const About = () => {
  // Add any custom logic here, such as fetching data or setting state

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h1 className="text-3xl font-bold mb-4">About Us</h1>
      <p>
        Welcome to the EDL Tool! This is where you can learn more about our tool's
        purpose, features, and how it can help you manage Edit Decision Lists (EDLs)
        efficiently.
      </p>
      <p className="mt-4">
        In the future, this page will include embedded content, tutorials, and more
        exciting features to enhance your experience.
      </p>
    </div>
  );
};

export default About;
